// Mock staff data — uses the unified users table structure
// emp_type: full_time | freelancer | contract
// status: active | on_leave | inactive

export interface StaffMember {
  id: string;
  emp_id: string;
  name: string;
  role: string;
  department: string;
  type: "Full Time" | "Freelancer" | "Contract";
  email: string;
  phone: string;
  skills: string[];
  joined_date: string;
  status: "active" | "on_leave" | "inactive";
  active_jobs: number;
  completed_jobs: number;
  utilization: number;
  avatar: string;
}

export const mockStaff: StaffMember[] = [
  {
    id: "usr-001", emp_id: "EMP-001", name: "Ravi Teja", role: "field_surveyor", department: "Field Operations",
    type: "Full Time", email: "ravi@cadsoft.in", phone: "+91 98001 11001",
    skills: ["Total Station", "DGPS", "Levelling", "AutoCAD"],
    joined_date: "2022-03-15", status: "active", active_jobs: 3, completed_jobs: 42, utilization: 85, avatar: "RT",
  },
  {
    id: "usr-002", emp_id: "EMP-002", name: "Suresh Kumar", role: "field_surveyor", department: "Field Operations",
    type: "Full Time", email: "suresh@cadsoft.in", phone: "+91 98001 11002",
    skills: ["Total Station", "Boundary Survey", "GPS"],
    joined_date: "2022-06-01", status: "active", active_jobs: 2, completed_jobs: 35, utilization: 72, avatar: "SK",
  },
  {
    id: "usr-003", emp_id: "EMP-003", name: "Kiran Babu", role: "field_surveyor", department: "Field Operations",
    type: "Full Time", email: "kiran@cadsoft.in", phone: "+91 98001 11003",
    skills: ["DGPS", "Total Station", "Drone Survey", "GIS"],
    joined_date: "2021-01-10", status: "active", active_jobs: 2, completed_jobs: 68, utilization: 90, avatar: "KB",
  },
  {
    id: "usr-004", emp_id: "EMP-004", name: "Naresh Yadav", role: "field_surveyor", department: "Field Operations",
    type: "Freelancer", email: "naresh@freelance.com", phone: "+91 98001 11004",
    skills: ["Total Station", "Levelling"],
    joined_date: "2023-08-20", status: "active", active_jobs: 1, completed_jobs: 18, utilization: 55, avatar: "NY",
  },
  {
    id: "usr-005", emp_id: "EMP-005", name: "Mahesh Babu", role: "field_surveyor", department: "Field Operations",
    type: "Full Time", email: "mahesh@cadsoft.in", phone: "+91 98001 11005",
    skills: ["Boundary Survey", "Revenue Survey", "GPS"],
    joined_date: "2023-02-14", status: "on_leave", active_jobs: 1, completed_jobs: 22, utilization: 40, avatar: "MB",
  },
  {
    id: "usr-006", emp_id: "EMP-006", name: "Priya Sharma", role: "survey_manager", department: "Management",
    type: "Full Time", email: "priya@cadsoft.in", phone: "+91 98001 11006",
    skills: ["Project Management", "AutoCAD", "GIS", "Reporting"],
    joined_date: "2020-07-01", status: "active", active_jobs: 8, completed_jobs: 120, utilization: 95, avatar: "PS",
  },
  {
    id: "usr-007", emp_id: "EMP-007", name: "Amit Patel", role: "office_staff", department: "Office",
    type: "Full Time", email: "amit@cadsoft.in", phone: "+91 98001 11007",
    skills: ["AutoCAD", "Civil 3D", "GIS", "KMZ/KML"],
    joined_date: "2021-09-15", status: "active", active_jobs: 5, completed_jobs: 89, utilization: 88, avatar: "AP",
  },
  {
    id: "usr-008", emp_id: "EMP-008", name: "Sanjay Drone", role: "field_surveyor", department: "Field Operations",
    type: "Full Time", email: "sanjay@cadsoft.in", phone: "+91 98001 11008",
    skills: ["DJI Phantom", "Pix4D", "Orthophoto", "Point Cloud"],
    joined_date: "2023-05-10", status: "active", active_jobs: 1, completed_jobs: 14, utilization: 60, avatar: "SD",
  },
  {
    id: "usr-009", emp_id: "EMP-009", name: "Lakshmi Devi", role: "office_staff", department: "Office",
    type: "Full Time", email: "lakshmi@cadsoft.in", phone: "+91 98001 11009",
    skills: ["QGIS", "ArcGIS", "Python", "Shapefile"],
    joined_date: "2022-11-01", status: "active", active_jobs: 3, completed_jobs: 31, utilization: 78, avatar: "LD",
  },
  {
    id: "usr-010", emp_id: "EMP-010", name: "Venkat Reddy", role: "lab_analyst", department: "Lab",
    type: "Contract", email: "venkat.lab@cadsoft.in", phone: "+91 98001 11010",
    skills: ["Soil Testing", "Lab Analysis", "Report Writing"],
    joined_date: "2024-01-15", status: "active", active_jobs: 1, completed_jobs: 8, utilization: 45, avatar: "VR",
  },
];

export const mockJobAssignmentHistory = [
  { userId: "usr-001", jobNo: "HYD-SURV-2026-04-0034", title: "Topographic Survey - Shamshabad", role: "Field Lead", status: "In Progress", from: "2026-04-01", to: "2026-04-20" },
  { userId: "usr-001", jobNo: "HYD-SURV-2026-03-0028", title: "As-Built Survey - Kukatpally Metro", role: "Field Surveyor", status: "Completed", from: "2026-03-10", to: "2026-03-30" },
  { userId: "usr-001", jobNo: "HYD-SURV-2026-04-0030", title: "Hydrogeological Survey - Vijayawada", role: "Field Surveyor", status: "In Progress", from: "2026-03-30", to: "2026-04-22" },
  { userId: "usr-002", jobNo: "HYD-SURV-2026-04-0029", title: "Boundary Survey - Kompally", role: "Field Surveyor", status: "In Progress", from: "2026-03-25", to: "2026-04-12" },
  { userId: "usr-002", jobNo: "HYD-SURV-2026-03-0025", title: "Revenue Survey - Medchal Mandal", role: "Field Surveyor", status: "Delivered", from: "2026-03-01", to: "2026-03-25" },
  { userId: "usr-003", jobNo: "HYD-SURV-2026-04-0033", title: "DGPS Survey - Outer Ring Road", role: "Senior Lead", status: "In Progress", from: "2026-03-28", to: "2026-04-09" },
  { userId: "usr-006", jobNo: "HYD-SURV-2026-04-0034", title: "Topographic Survey - Shamshabad", role: "Office Coordinator", status: "In Progress", from: "2026-04-01", to: "2026-04-20" },
  { userId: "usr-007", jobNo: "HYD-SURV-2026-04-0033", title: "DGPS Survey - Outer Ring Road", role: "CAD Processing", status: "In Progress", from: "2026-03-28", to: "2026-04-09" },
];

// Legacy alias for backward compatibility
export const mockEmployeesFull = mockStaff;